(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vuejs-mobile-datepicker", [], factory);
	else if(typeof exports === 'object')
		exports["vuejs-mobile-datepicker"] = factory();
	else
		root["vuejs-mobile-datepicker"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition